// extracted by mini-css-extract-plugin
export default {"content":"qFEyaeB7yeLhn1H8u541","text":"eTifodx9xiUPZNJxohZE"};